// 仅用于地图编辑草稿的规则单元重铺；不修改学生运行或已发布快照。
export function gridSize (form) {
  return { rows: Number(form.rows), cols: Number(form.cols), width: Number(form.width), height: Number(form.height) }
}

export function gridSizeError (size) {
  if (![size.rows, size.cols].every(value => Number.isInteger(value) && value >= 1 && value <= 100)) return '行数、列数须为1～100的整数'
  if (size.rows * size.cols > 2000) return '单张地图最多2000个底图单元，请减少行数或列数'
  if (![size.width, size.height].every(value => Number.isFinite(value) && value > 0 && value <= 1000000)) return '地图宽度、高度须为大于0且不超过1000000的有限数值'
  return ''
}

export function sameGridSize (left, right) {
  return !!left && !!right && ['rows', 'cols', 'width', 'height'].every(key => left[key] === right[key])
}

export function isRegularGridCell (cell, size) {
  if (!size || String(cell.geometry?.type).toUpperCase() !== 'RECTANGLE') return false
  const expected = { x: cell.col * size.width / size.cols, y: cell.row * size.height / size.rows, width: size.width / size.cols, height: size.height / size.rows }
  return Object.keys(expected).every(key => Number.isFinite(Number(cell.geometry[key])) && Math.abs(Number(cell.geometry[key]) - expected[key]) < 1e-7)
}

export function resizeGridCells (previous, size, preserve = true) {
  const error = gridSizeError(size)
  if (error) throw new Error(error)
  const positions = new Map()
  if (preserve) previous.forEach(cell => { if (cell.row >= 0 && cell.row < size.rows && cell.col >= 0 && cell.col < size.cols) positions.set(cell.row + ':' + cell.col, cell) })
  const used = new Set([...positions.values()].map(cell => cell.id))
  const cells = []
  for (let row = 0; row < size.rows; row++) for (let col = 0; col < size.cols; col++) {
    const previousCell = positions.get(row + ':' + col)
    let id = previousCell?.id || 'C' + row + '_' + col
    if (!previousCell) { const base = id; let suffix = 1; while (used.has(id)) id = base + '_' + suffix++ }
    used.add(id)
    // 用相邻边界的差值构造宽高，末行末列精确落在地图边界，避免800/6等浮点累加越界。
    const x = col * size.width / size.cols; const y = row * size.height / size.rows
    const right = col === size.cols - 1 ? size.width : (col + 1) * size.width / size.cols
    const bottom = row === size.rows - 1 ? size.height : (row + 1) * size.height / size.rows
    const width = right - x; const height = bottom - y
    cells.push({ zone: '居住区', population: 50, economy: 50, risk: 1, dividable: true, ...previousCell,
      id, row, col, area: width * height, geometry: { type: 'RECTANGLE', x, y, width, height } })
  }
  return cells
}
